<template>
  <div class="toggle">
    <toggle-button
      class="toggle-btn"
      :color="color"
      :height="height"
      :name="name"
      :sync="true"
      :value="value"
      :width="width"
      @change="$value => emitUpdate($value.value)"
    />
    <span class="toggle__text"><slot /></span>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  name: 'OvpToggle',

  components: {
    ToggleButton,
  },

  model: {
    prop: 'value',
    event: 'update',
  },

  props: {
    name: {
      type: String,
      required: true,
    },

    validate: {
      type: Object,
      default: () => {},
    },

    value: {
      type: Boolean,
    },

    width: {
      type: Number,
      default: 35,
    },

    height: {
      type: Number,
      default: 20,
    },

    color: {
      type: [String, Object],
      default() {
        return '#5bac26'
      },
    },
  },

  methods: {
    emitUpdate(value) {
      this.validate?.$touch()

      this.$emit('update', value)
    },
  },
}
</script>

<style name="mobile" scoped>
.toggle {
  display: inline-block;
  min-height: 25px;
  line-height: 25px;

  &__text {
    padding: 5px 0 0 0;
    margin-left: 5px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
  }

  &:hover {
    .toggle__text {
      color: var(--c-original-green);
    }
  }
}
</style>
